import React from 'react'
import PdfPage from '../components/PdfPage'
import "./index.css"
export default function RsikDiscloure() {
  return (
    <main>
      <PdfPage
        h2={"Risk Disclousre"}
        img={"/img/risk-disclosure.jpg"}
        pdf1={"https://api.orbitsecurities.com.pk/media/cms/documents/risk-closure-english.pdf"}
        pdf1Text={"Risk Disclousre In English"}
        pdf2={"https://api.orbitsecurities.com.pk/media/cms/documents/risk-closure-urdu.pdf"}
        pdf2Text={"Risk Disclousre In Urdu"}
      />
    </main>)
}

